import {Constants} from "../constants/Constants";
import React from "react";
import {Typography} from "@material-ui/core";
import AppColors from '../colors/AppColors';
import {blueGrey} from "@material-ui/core/colors";
import {useFeatureItemStyle} from '../styles/FeatureItemStyle';
import clsx from 'clsx';

export default function FeatureItem(props: any) {

    const classes = useFeatureItemStyle();
    const titleColor = props[Constants.TITLE_COLOR];
    const descriptionColor = props[Constants.DESCRIPTION_COLOR];

    const title = props[Constants.TITLE];
    const description = props[Constants.DESCRIPTION];

    return (
        <div
            onClick={props.handler}
            className={clsx(classes.root, titleColor && classes.whiteRoot)}>
            <Typography
                style={{color: titleColor ?? AppColors.lightenOrDarken(AppColors.WHITE_SMOKE, 10), fontWeight: 600}}
                dangerouslySetInnerHTML={{__html: title}}/>
            <Typography style={{
                color: descriptionColor ?? AppColors.lightenOrDarken(blueGrey[200], 20),
                fontWeight: 400,
                fontSize: 15
            }} dangerouslySetInnerHTML={{__html: description}}/>
        </div>
    );

}